import React from "react";

// Component
import MainView from "../components/MainView";

// Assets
import contactImg from "../assets/core/img/contact.png";
import goodboostImg from "../assets/core/img/goodboost.png";
import omdenaImg from "../assets/core/img/omdena.png";
import personImg from "../assets/core/img/person.png";
import birdImg from "../assets/core/img/bird.png";

export default function About() {
  return (
    <MainView>
      <div className="pt-20 pb-20 px-[5vw] lg:px-[9vw] 2xl:px-[15vw]">
        <div className="flex flex-col sm:flex-row-reverse sm:items-center sm:justify-between mx-auto xl:max-wxl">
          <div className="sm:w-[25%]">
            <img
              src={personImg}
              alt=""
              className="mx-auto w-[80%] sm:w-[80%]"
            />
          </div>
          <div className="mt-4 sm:mt-0 sm:w-[65%]">
            <div className="font-retro-rounded text-xl xl:text-3xl text-center">
              <p>
                RETROrehab is a series of interactive exercise games created by
                Good Boost as part of an industrial research project for healthy
                ageing, funded by the Small Business Research Initiative (SBRI).
                These activities aim to gamify exercises that are regularly used
                as part of a rehabilitation programme to improve coordination,
                balance and daily activities.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="pb-20 px-[5vw] lg:px-[10vw] 2xl:px-[15vw]">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mx-auto xl:max-wxl">
          <div className="sm:w-[25%]">
            <img src={birdImg} alt="" className="mx-auto w-[80%] sm:w-[80%]" />
          </div>
          <div className="mt-4 sm:mt-0 sm:w-[65%]">
            <div className="font-retro-rounded text-xl xl:text-3xl text-center">
              <p>
                Good Boost has co-designed the digital exercise programmes with
                older adults, who have informed the exercises gamified elements
                that are reflective of ‘arcade games’, making the exercises fun
                with game play based around existing arcade games concepts to
                minimise learning and on-boarding time.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="pb-20 px-[5vw] lg:px-[10vw] 2xl:px-[15vw]">
        <div className="flex justify-center mx-auto xl:max-wxl">
          <div>
            <img
              src={contactImg}
              alt=""
              className="cursor-pointer"
              onClick={(e) => {
                window.location.href = "mailto:info@goodboost.org";
                e.preventDefault();
                console.log("click");
              }}
            />
          </div>
        </div>
      </div>

      <div className="pb-20 px-[5vw] lg:px-[8vw] 2xl:px-[15vw]">
        <p className="pb-10 sm:pb-20 font-retro-rounded font-bold text-xl xl:text-2xl text-center">
          RetroRehab is powered by Good Boost and has been developed with the
          support and input of Omdena
        </p>

        <div className="pb-10 sm:pb-20 flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-center mx-auto xl:max-w-6xl">
          <div className=" sm:w-[12%]">
            <img src={goodboostImg} alt="" className="mx-auto" />
          </div>
          <div className=" mt-4 sm:mt-0 sm:w-[80%]">
            <div className="font-retro-rounded text-xl xl:text-2xl text-center sm:text-left">
              <p>
                Good Boost is a social enterprise that develops digital
                technology to deliver affordable and accessible therapeutic
                exercise programmes for musculoskeletal (MSK) conditions.
              </p>
            </div>
          </div>
        </div>

        <div className="pb-10 sm:pb-20 flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-center mx-auto xl:max-w-6xl">
          <div className=" sm:w-[12%]">
            <img src={omdenaImg} alt="" className="mx-auto" />
          </div>
          <div className=" mt-4 sm:mt-0 sm:w-[80%]">
            <div className="font-retro-rounded text-xl xl:text-2xl text-center sm:text-left">
              <p>
                Omdena is a platform to bring together the global AI community
                with impACT-driven organizations to educate, innovate, and build
                real-world AI solutions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </MainView>
  );
}
